import React from 'react';

import EditableTextView from '../../../../../../components/EditableTextView';

const onHeadingChange = (itemId, dispatch, headingKey) => (html) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    [headingKey]: html
  });
};

const editorOptions = {
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' },
      'unorderedlist',
      'orderedlist'
    ]
  }
};

const onParagraphChange = (itemId, dispatch) => (html) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    paragraph: html
  });
};

function renderContent(lesson, editable, dispatch) {
  const variant = lesson.variant;
  const firstItem = lesson.items[0];
  const secondItem = lesson.items[1];

  switch (variant) {
    case 'paragraph':
    case 'headingParagraph':
    case 'subheadingParagraph':
      return (
        <EditableTextView
          text={firstItem.paragraph}
          placeholder="Enter text here..."
          wrapperClassName="brand--body brand--linkColor"
          editable={editable}
          itemId={firstItem._id}
          onChange={onParagraphChange(firstItem._id, dispatch)}
          editorOptions={editorOptions}
        />
      );
    case 'twoColumn':
      return [
        <EditableTextView
          key={1}
          text={firstItem.paragraph}
          placeholder="Enter text here..."
          wrapperClassName="blockTextCol brand--body brand--linkColor"
          editable={editable}
          itemId={firstItem._id}
          onChange={onParagraphChange(firstItem._id, dispatch)}
          editorOptions={editorOptions}
        />,
        <EditableTextView
          key={2}
          text={secondItem.paragraph}
          placeholder="Enter text here..."
          wrapperClassName="blockTextCol brand--body brand--linkColor"
          editable={editable}
          itemId={secondItem._id}
          onChange={onParagraphChange(secondItem._id, dispatch)}
          editorOptions={editorOptions}
        />
      ];
    default:
      return null;
  }
}

function renderHeading(lesson, editable, dispatch) {
  const variant = lesson.variant;
  const item = lesson.items[0];

  let HeadingTag = 'h3';
  switch (variant) {
    case 'heading':
    case 'headingParagraph':
      HeadingTag = 'h2';
      break;
    case 'subheadingParagraph':
    case 'subheading':
      HeadingTag = 'h3';
      break;
    default:
      return null;
  }

  return (
    <div className="brand--head">
      <HeadingTag>
        <EditableTextView
          text={item.heading}
          placeholder="Enter heading"
          editable={editable}
          itemId={item._id}
          onChange={onHeadingChange(item._id, dispatch, 'heading')}
          editorOptions={{
            disableReturn: true,
            toolbar: {
              buttons: [
                { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
                { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
                { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' }
              ]
            },
            keyboardCommands: {
              commands: [
                {
                  command: false,
                  key: 'B',
                  meta: true,
                  shift: false
                },
                {
                  command: false,
                  key: 'I',
                  meta: true,
                  shift: false
                }
              ]
            }
          }}
        />
      </HeadingTag>
    </div>
  );
}

function getVariantClassName(variant) {
  switch (variant) {
    case 'paragraph':
    case 'headingParagraph':
    case 'subheadingParagraph':
      return 'block-text--onecol';
    case 'heading':
    case 'subheading':
      return 'block-text--heading';
    case 'twoColumn':
      return 'block-text--twocol';
    default:
      return null;
  }
}

export default (props) => {
  const lesson = props.lesson;
  const variant = lesson.variant;

  const variantClassName = getVariantClassName(variant);

  const settings = lesson.settings;
  const { paddingBottom, paddingTop, backgroundColor } = settings;

  const style = {
    paddingBottom: paddingBottom * 10,
    paddingTop: paddingTop * 10,
    backgroundColor
  };

  const { editable, dispatch } = props;
  return (
    <div
      className={`block-text ${variantClassName}`}
      style={Object.assign(
        {},
        style,
        variant === 'heading' || variant === 'subheading' ? { paddingBottom: '0px' } : {}
      )}
    >
      <div className="">
        <div className="">{renderHeading(lesson, editable, dispatch)}</div>
        <div className="">{renderContent(lesson, editable, dispatch)}</div>
      </div>
    </div>
  );
};
